import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import { FC, createElement, ReactNode, useState, CSSProperties } from 'react';
import Header from './header';
import styles from './index.module.less';
import { IconFont } from '@/components';
import cs from 'classnames';
import { useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;

export interface BaseLayoutProps {
  children?: ReactNode;
  location?: any;
  info?: any;
  openKeys?: any;
  items: any;
  onSelect?: (any) => void;
  onOpenChange: (any) => void
  selectKeys?: any;
  crumbs?: any[];
  inMicro?: boolean, // 是否在微应用中使用
}


const BaseLayout: FC<BaseLayoutProps> = ({
  children,
  info,
  items,
  onSelect,
  selectKeys,
  onOpenChange,
  openKeys,
  crumbs,
  inMicro,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const { name, companyName: tenant } = info;

  const location = useLocation();
  const pathname = location.pathname;

  const onCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const layoutStyle = (window.__POWERED_BY_QIANKUN__ || pathname === '/business' || pathname === '/ppt') ? { position: 'relative' } : { position: 'relative', marginLeft: collapsed ? 80 : 200 };
  return (
    // <div>
    //   <CustomerHeader/>
    //   <div style={{ width: 256 }}>
    //     <Button type='primary' onClick={toggleCollapsed} style={{ marginBottom: 16 }}>
    //       {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
    //     </Button>
    //
    //   </div>
    // </div>
    <Layout hasSider className={cs(styles.container, inMicro ? styles['container--micro'] : styles['container--main'])}>
      {
        window.__POWERED_BY_QIANKUN__ || pathname === '/business' || pathname === '/ppt' ? null
          : <Sider
            collapsible
            trigger={null}
            collapsed={collapsed}
            style={{
              overflow: 'auto',
              height: '100vh',
              position: 'fixed',
              left: 0,
              top: 0,
              bottom: 0,
              flex: '0 0 200px',
              width: 200,
              zIndex: 4,
            }} >
            <div className={cs(styles.logo, collapsed && styles.collapsedStyle)}>
              <IconFont iconHref={!collapsed ? 'res-servise-ic_logo_pc' : 'res-servise-logotu'} className={cs(styles.icon)} />
            </div>
            <Menu
              theme='dark'
              mode='inline'
              selectedKeys={selectKeys}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              onSelect={onSelect}
              items={items}
            /></Sider>
      }
      <Layout style={layoutStyle as CSSProperties}>
        {/* 微前端环境需要隐藏 头部 */}
        {
          (!window.__POWERED_BY_QIANKUN__ && pathname !== '/business' && pathname !== '/ppt') && (
            <Header
              collapsIcon={createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                onClick: onCollapsed,
              })}
              name={name}
              tenant={tenant}
              crumbs={crumbs}
            />
          )
        }
        <Content className={styles.main}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default BaseLayout;
